import { useState } from "react";
import papi from "@/lib/portalApi";
import { usePortal } from "@/lib/portalCtx";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Mail, UserRound, MessageCircle } from "lucide-react";
import PortalTour from "@/pages/portail/PortalTour";

const initials = (n) => n.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

const wa = (t) => { const d = (t || "").replace(/\D/g, ""); return d.length >= 8 ? `https://wa.me/${d.length === 8 ? `228${d}` : d}` : ""; };

export default function WelcomeDialog() {
  const { me } = usePortal();
  const [open, setOpen] = useState(!!me.welcome);
  const [tour, setTour] = useState(false);
  if (!me.welcome) return null;
  const close = () => { setOpen(false); setTour(true); papi.post("/me/welcome").catch(() => {}); };
  if (tour) return <PortalTour onDone={() => setTour(false)} />;
  const first = (me.client_name || "").split(" ")[0];
  const people = me.welcome.people;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="w-[calc(100vw-24px)] max-w-md p-0 overflow-hidden rounded-2xl" data-testid="portal-welcome-dialog">
        <div className="bg-[#076633] text-white px-6 pt-7 pb-6">
          <img src="/logo-omnibat.png" alt="OMNIBAT" className="h-9 bg-white rounded-lg p-1.5 mb-5" />
          <DialogHeader><DialogTitle className="text-2xl font-head text-white text-left" data-testid="portal-welcome-title">Bienvenue {first} !</DialogTitle></DialogHeader>
          <p className="text-sm text-emerald-50 mt-2">Merci de votre confiance. Dans votre espace client, vous suivez votre chantier en temps réel : avancement, photos, documents, devis, factures et paiements.</p>
        </div>
        <div className="px-6 py-5 space-y-3">
          <p className="text-xs uppercase tracking-wider text-slate-400">{people.length ? "Vos interlocuteurs" : "Votre interlocuteur"}</p>
          {people.length ? people.map((p, i) => (
            <div key={i} className="flex items-center gap-3 rounded-xl border p-3" data-testid={`portal-welcome-person-${i}`}>
              <div className="h-12 w-12 shrink-0 rounded-full overflow-hidden bg-emerald-50 text-[#076633] font-semibold flex items-center justify-center">{p.photo ? <img src={p.photo} alt={p.name} className="h-full w-full object-cover" data-testid={`portal-welcome-photo-${i}`} /> : initials(p.name) || <UserRound className="h-5 w-5" />}</div>
              <div className="min-w-0 flex-1">
                <p className="text-[11px] text-[#076633] font-medium">{p.role}</p>
                <p className="font-semibold truncate">{p.name}</p>
                {p.function && <p className="text-xs text-slate-500 truncate">{p.function}</p>}
                {p.whatsapp && <p className="text-xs text-slate-500 truncate" data-testid={`portal-welcome-phone-${i}`}>WhatsApp : {p.whatsapp}</p>}
              </div>
              {wa(p.whatsapp) && <a href={wa(p.whatsapp)} target="_blank" rel="noreferrer" title={p.whatsapp} className="p-2 rounded-full bg-emerald-50 text-[#076633] hover:bg-emerald-100" data-testid={`portal-welcome-whatsapp-${i}`}><MessageCircle className="h-4 w-4" /></a>}
              {p.email && <a href={`mailto:${p.email}`} className="p-2 rounded-full hover:bg-slate-100 text-slate-500" data-testid={`portal-welcome-mail-${i}`}><Mail className="h-4 w-4" /></a>}
            </div>
          )) : <p className="text-sm text-slate-600">L'équipe OMNIBAT reste à votre écoute via la rubrique Messages.</p>}
          <Button onClick={close} className="w-full h-11 rounded-xl bg-[#076633] hover:bg-[#065a2c] text-white mt-2" data-testid="portal-welcome-start">Découvrir mon espace</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
